import { css } from 'styled-system/css';

export const sidebarToggleButtonStyle = {
	headerMenuLine: css({
		backgroundColor: 'whiteOpacity.100',
	}),
}